import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import AddIcon from '@mui/icons-material/Add';
import { GridRowModes, GridSlotProps, GridToolbarContainer } from '@mui/x-data-grid-premium';

const EditToolbarRelatedContacts = (props: GridSlotProps['toolbar'] & { showButton?: boolean }) => {
  const { setRows, setRowModesModel, showButton = true } = props;

  const handleClick = () => {
    const id = crypto.randomUUID();

    setRows((oldRows) => [...oldRows, { id, nameSurname: '', email: '', phoneNumber: '', isNew: true }]);

    setRowModesModel((oldModel) => ({
      ...oldModel,
      [id]: { mode: GridRowModes.Edit, fieldToFocus: 'name' },
    }));
  };

  if (!showButton) return <></>;

  return (
    <GridToolbarContainer>
      <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
        <FormattedMessage id="project.table.addRow" defaultMessage="Satır Ekle" />
      </Button>
    </GridToolbarContainer>
  );
};

export default EditToolbarRelatedContacts;
